import { FC } from 'react';
import { makeStyles, Theme, Typography } from '@material-ui/core';

interface Content {
  title?: string;
  text: string;
}

interface DevOpsKnowProps {
  contents: Array<Content>;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(2),
    '& span': {
      fontWeight: 700,
      color: theme.palette.switchedColors,
    },
  },
}));

const DevOpsKnow: FC<DevOpsKnowProps> = ({ contents }) => {
  const classes = useStyles();
  return (
    <>
      {contents.map(({ title, text }, index) => (
        <Typography variant="body2" key={index} className={classes.root}>
          <Typography variant="body2" component="span" color="primary">
            {title}
          </Typography>
          {text}
        </Typography>
      ))}
    </>
  );
};

export default DevOpsKnow;
